import { render, staticRenderFns } from "./MyDocumentsListItem.vue?vue&type=template&id=1e52d21f&scoped=true&"
import script from "./MyDocumentsListItem.vue?vue&type=script&lang=ts&"
export * from "./MyDocumentsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./MyDocumentsListItem.vue?vue&type=style&index=0&id=1e52d21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52d21f",
  null
  
)

export default component.exports